import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import {dayjsFromSeconds, formatDate} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault, renderSelf} from 'views/Shared'
import {renderIf} from "../../Shared";
import {GoDotFill} from "react-icons/go";

const ItemDescription = ({
  title,
  description,
  Wrapper = 'div',
  contentClassName = 'font-semibold text-color-100 ml-1',
}) => {
  const t = useTranslate()
  return (
    <Wrapper className="flex items-baseline gap-1 text-xs leading-tight">
        <GoDotFill size={10} className="text-color-400" />
        <span className="text-color-500 italic">
            {`${t(title)} : `}
        </span>
        <span className={contentClassName}>
            {description}
        </span>
    </Wrapper>
  )
}

export const renderExaminationPaperItem = ({ renderContextMenu = NullAsDefault }) => (item, index) => {
    const { examination, examinee_name} = item ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <div className="py-2 flex flex-col gap-1 rounded-lg custom-item-render custom-render-border relative">
                    <div className="space-x-2 mr-6">
                        <span className="text-sm text-color-300 whitespace-no-wrap italic">{t('exam of')}</span>
                        <span className="font-bold text-color-000">
                      {renderIf(
                          item?.prefix_title,
                          <span className="font-medium text-sm text-color-200 italic">
                              {`${item?.prefix_title} `}
                          </span>
                      )}
                            {examinee_name}
                  </span>
                        <span className="text-sm text-color-300 italic">
                      {t('in the {n} test', {
                          n: <Link
                              to={getLinkToDetail(item)}
                              className="px-1 font-semibold text-blue-500 no-underline">
                              {getTitle(examination)}
                          </Link>
                      })}
                  </span>
                    </div>
                    <div className="ml-0 md:ml-2 grid grid-cols-1 md:grid-cols-2 gap-1">
                        {[
                            {
                                label: 'correct answers',
                                name: 'total_corrects',
                                defaultValue: 0,
                            },
                            {
                                label: 'ranking',
                                name: 'score_ranking',
                                defaultValue: t('no data'),
                                transform: (value) => {
                                    let _class
                                    switch (value) {
                                        case 'passed' :
                                            _class = 'font-bold text-blue-600'
                                            break;
                                        case 'credit' :
                                            _class = 'font-bold text-orange-600'
                                            break;
                                        case 'distinction' :
                                            _class = 'font-bold text-green-600'
                                            break;
                                        case 'failed' :
                                            _class = 'font-bold text-red-300'
                                            break;
                                        default :
                                            _class = 'font-medium text-color-100'
                                            break;
                                    }
                                    return (
                                        <span className={_class}>{value ? t(value) : t('no data')}</span>
                                    )
                                }
                            },
                            {
                                label: 'total point',
                                name: 'final_score',
                                defaultValue: 0,
                            },
                            {
                                label: 'time for test',
                                name: 'working_time_in_seconds',
                                transform: (value) =>
                                    dayjsFromSeconds(value)?.format('HH:mm:ss'),
                            },
                            {
                                label: 'start',
                                name: 'started_at',
                                defaultValue: t('no data'),
                                transform: (value) =>
                                    value ? formatDate(value,'HH:mm - DD/MM/YYYY') : null,
                            },
                            {
                                label: 'end',
                                name: 'finished_at',
                                defaultValue: t('no data'),
                                transform: (value) =>
                                    value ? formatDate(value,'HH:mm - DD/MM/YYYY') : null,
                            },
                        ].map(
                            (
                                {
                                    name,
                                    label,
                                    defaultValue,
                                    transform = renderSelf,
                                    render = (child, params) => child,
                                    ...rest
                                },
                                index,
                                array
                            ) => {
                                const value = _.get(item, name)
                                return render(
                                    <ItemDescription
                                        key={index}
                                        title={label}
                                        description={transform(value) || defaultValue}
                                    />,
                                    {
                                        name,
                                        value,
                                        transform,
                                        defaultValue,
                                        getValue: (name) => _.find(array, { name }),
                                        ...rest,
                                    }
                                )
                            }
                        )}
                    </div>
                    <div className="absolute right-5 top-5 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}
